module.exports = __webpack_public_path__ + "static/media/fa-past.8ec58d51.png";